/**
 * API接口封装
 */
import request from '../utils/request.js';

// 用户相关接口
export const user = {
	// 登录
	login: (data) => {
		return request.post('api/user/checkIn', {
			...data,
			tab: 'login'
		});
	},
	
	// 注册
	register: (data) => {
		return request.post('api/user/checkIn', {
			...data,
			tab: 'register'
		});
	},
	
	// 退出登录
	logout: () => {
		return request.post('api/user/logout');
	},
	
	// 获取用户信息
	getProfile: () => {
		return request.get('api/account/profile');
	},
	
	// 获取用户邀请码佣金信息
	getInviteCommission: () => {
		return request.get('api/user/getUserInviteCommission');
	}
};

// 店铺相关接口
export const shop = {
	// 获取店铺信息
	getShopInfo: () => {
		return request.get('frontend/shop/info', {
			server: 1
		});
	},
	
	// 获取用户店铺信息
	getInfo: () => {
		return request.get('api/user/getUserShop');
	},
	
	// 创建用户店铺
	create: (data = {}) => {
		return request.post('api/user/createUserShop', data);
	},
	
	// 获取店铺商品列表
	getProducts: (params = {}) => {
		return request.get('frontend/shop/products', {
			server: 1,
			...params
		});
	},
	
	// 获取店铺访问统计
	getVisitStats: () => {
		return request.get('frontend/shop/today-stats', {
			server: 1
		});
	},

	// 生成店铺海报
	generatePoster: () => {
		return request.post('api/shop/generatePoster', {
			server: 1
		});
	}
};

// 产品相关接口
export const product = {
	// 获取产品列表
	getList: (params = {}) => {
		return request.post('api/product/index', params);
	},
	
	// 获取产品详情（店铺版本，需要shopCode）
	getDetail: (id, shopCode) => {
		return request.get('api/shop/getProductDetail', {
			id,
			shop_code: shopCode
		});
	},
	
	// 获取产品详情（通用版本，只需要产品ID）
	getDetailById: (id) => {
		return request.get(`frontend/product/detail`, {
			id,
			server: 1
		});
	}
};

// 订单相关接口
export const order = {
	// 获取订单列表
	getList: (params = {}) => {
		return request.get('api/order/list', params);
	},
	
	// 获取订单详情
	getDetail: (id) => {
		return request.get('api/order/detail', {
			id
		});
	},
	
	// 提交订单
	submit: (data) => {
		return request.post('api/shop/submitOrder', data);
	}
};

// 快递查询接口
export const express = {
	// 查询快递信息
	query: (data) => {
		return request.post('api/express/query', data);
	}
};

// 下级相关接口
export const referral = {
	// 获取直属下级列表
	getDirectDownlines: (params = {}) => {
		return request.get('api/referral/getDirectDownlines', params);
	},
	
	// 获取所有下级列表
	getAllDownlines: (params = {}) => {
		return request.get('api/referral/getAllDownlines', params);
	},
	
	// 获取统计数据
	getStats: () => {
		return request.get('api/referral/getStats');
	}
};

// 用户相关接口
export const userApi = {
  // 登录
  login(data) {
    // 构建请求参数
    let apiParams = { ...data };
    
    // 如果是登录请求，确保格式正确
    if (data.tab === 'login') {
      // 设置默认的保持登录参数
      if (apiParams.keep === undefined) {
        apiParams.keep = true;
      }
    }
    
    // 注册请求也是通过checkIn接口，但参数结构不同
    // 确保适配不同的请求类型
    
    return request.post('api/user/checkIn', apiParams)
      .then(response => {
        // 处理响应
        if (response && response.code === 0) {
          // API返回错误
          const error = new Error(response.msg || '请求失败');
          error.data = response;
          throw error;
        }
        
        // 检查是否包含token - 处理各种可能的数据结构
        if (response && response.data) {
          // 情况1: userInfo中没有token
          if (response.data.userInfo && !response.data.userInfo.token) {
            // 尝试从其他可能的字段获取token
            if (response.data.token) {
              response.data.userInfo.token = response.data.token;
            }
          }
          
          // 情况2: 没有userInfo但有token
          if (!response.data.userInfo && response.data.token) {
            response.data.userInfo = {
              token: response.data.token
            };
            
            // 尝试添加其他用户信息
            if (response.data.user) {
              Object.assign(response.data.userInfo, response.data.user);
            }
          }
        }
        
        // 确保返回的数据格式正确
        if (response && response.data) {
          return response.data;
        }
        
        return response;
      })
      .catch(error => {
        throw error;
      });
  },
  
  // 短信验证码登录
  smsLogin(data) {
    return request.post('api/user/smsLogin', data)
      .then(response => {
        // 处理响应
        if (response && response.code === 0) {
          // API返回错误
          const error = new Error(response.msg || '短信登录失败');
          error.data = response;
          throw error;
        }
        
        // 检查是否包含token - 处理各种可能的数据结构
        if (response && response.data) {
          // 情况1: userInfo中没有token
          if (response.data.userInfo && !response.data.userInfo.token) {
            // 尝试从其他可能的字段获取token
            if (response.data.token) {
              response.data.userInfo.token = response.data.token;
            }
          }
          
          // 情况2: 没有userInfo但有token
          if (!response.data.userInfo && response.data.token) {
            response.data.userInfo = {
              token: response.data.token
            };
            
            // 尝试添加其他用户信息
            if (response.data.user) {
              Object.assign(response.data.userInfo, response.data.user);
            }
          }
        }
        
        // 确保返回的数据格式正确
        if (response && response.data) {
          return response.data;
        }
        
        return response;
      })
      .catch(error => {
        throw error;
      });
  },
  
  // 发送短信验证码
  sendSms(data) {
    if (!data.mobile || !/^1\d{10}$/.test(data.mobile)) {
      return Promise.reject(new Error('手机号格式错误'));
    }
    
    if (!data.scene) {
      return Promise.reject(new Error('缺少场景参数'));
    }
    
    return request.post('api/stsms/send', data)
      .then(response => {
        // 检查响应格式 - 后台返回的是标准格式
        if (response && response.code === 0) {
          const error = new Error(response.msg || '发送验证码失败');
          error.data = response;
          throw error;
        }
        
        // 成功的情况：code === 1 或者没有code字段但有成功标识
        if (response && (response.code === 1 || response.msg === '验证码发送成功')) {
          return response.data || response;
        }
        
        // 如果响应格式不符合预期，也认为成功（兼容处理）
        return response.data || response;
      })
      .catch(error => {
        throw error;
      });
  },
  
  // 获取用户信息
  getUserInfo() {
    // 获取token
    const token = uni.getStorageSync('token');
    if (!token) {
      return Promise.resolve({ type: 'need login', msg: '请先登录' });
    }
    
    // 使用ba-user-token头而不是Authorization头
    const headers = {
      'ba-user-token': token
    };
    
    // 尝试获取用户信息
    return request.get('api/user/info', {}, { header: headers })
      .then(response => {
        if (response && response.type === 'need login') {
          return { type: 'need login' };
        }
        
        // 处理成功响应
        if (response && response.data && typeof response.data === 'object') {
          return response.data;
        }
        
        // 如果响应本身就是用户信息对象
        if (response && typeof response === 'object' && !Array.isArray(response)) {
          if (response.id || response.username || response.nickname || response.mobile) {
            return response;
          }
        }
        
        throw new Error('获取用户信息失败：响应格式不正确');
      })
      .catch(error => {
        if (error.statusCode === 303 || error.statusCode === 401) {
          return { type: 'need login' };
        }
        throw error;
      });
  },
  
  // 尝试多个API端点
  _tryMultipleEndpoints(endpoints, headers) {
    // 使用递归方式尝试多个端点
    const tryEndpoint = (index) => {
      if (index >= endpoints.length) {
        return Promise.resolve({ type: 'need login', msg: '所有API端点都失败' });
      }
      
      const endpoint = endpoints[index];
      
      return request.get(endpoint, {}, { header: headers })
        .then(response => {
          // 检查是否需要继续尝试
          if (response && response.type === 'need login') {
            return tryEndpoint(index + 1);
          }
          
          return response;
        })
        .catch(error => {
          return tryEndpoint(index + 1);
        });
    };
    
    return tryEndpoint(0);
  },
  
  // 从响应中提取用户信息
  _extractUserInfo(response) {
    // 处理返回数据 - 检查多种可能的数据结构
    if (response) {
      // 情况1: response.data.user 包含用户信息
      if (response.data && response.data.user) {
        return response.data.user;
      }
      
      // 情况2: response.data.userInfo 包含用户信息
      if (response.data && response.data.userInfo) {
        return response.data.userInfo;
      }
      
      // 情况3: response.userInfo 包含用户信息
      if (response.userInfo) {
        return response.userInfo;
      }
      
      // 情况4: response.user 包含用户信息
      if (response.user) {
        return response.user;
      }
      
      // 情况5: response.data 本身就是用户信息
      if (response.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
        // 检查是否包含用户信息的关键字段
        if (response.data.id || response.data.username || response.data.mobile || response.data.nickname) {
          return response.data;
        }
      }
      
      // 情况6: response 本身就是用户信息
      if (typeof response === 'object' && !Array.isArray(response)) {
        // 检查是否包含用户信息的关键字段
        if (response.id || response.username || response.mobile || response.nickname) {
          return response;
        }
      }
    }
    return null;
  },
  
  // 修改用户信息
  updateUserInfo(data) {
    return request.post('frontend/user/update?server=1', data)
      .then(response => {
        if (response && response.code === 0) {
          const error = new Error(response.msg || '更新用户信息失败');
          error.data = response;
          throw error;
        }
        return response.data || response;
      });
  }
};

// 产品相关接口
export const productApi = {
  // 获取产品分类
  getCategories() {
    return request.get('frontend/product/categories');
  },

  // 获取产品列表 - 使用API控制器接口
  getList(params) {
    return request.post('api/product/index', params);
  },

  // 获取产品详情
  getDetail(id) {
    return request.get(`frontend/product/detail/${id}`);
  },

  // 获取推荐产品
  getRecommend() {
    return request.get('frontend/product/recommend');
  }
};

// 订单相关接口
export const orderApi = {
  // 获取订单列表
  getList(params) {
    return request.get('frontend/order/list', params);
  },
  
  // 获取订单详情
  getDetail(id) {
    return request.get(`frontend/order/detail/${id}`);
  },
  
  // 创建订单
  create(data) {
    return request.post('frontend/order/create', data);
  },
  
  // 取消订单
  cancel(id) {
    return request.post(`frontend/order/cancel/${id}`);
  },
  
  // 支付订单
  pay(id, data) {
    return request.post(`frontend/order/pay/${id}`, data);
  },
  
  // 确认收货
  confirm(id) {
    return request.post(`frontend/order/confirm/${id}`);
  }
};

// 推广相关接口
export const promotionApi = {
  // 获取推广数据
  getData() {
    return request.get('frontend/promotion/data');
  },
  
  // 获取下级用户列表
  getSubordinates(params) {
    return request.get('frontend/promotion/subordinates', params);
  },
  
  // 获取佣金记录
  getCommissions(params) {
    return request.get('frontend/promotion/commissions', params);
  },
  
  // 佣金提现
  withdraw(data) {
    return request.post('frontend/promotion/withdraw', data);
  },
  
  // 获取推广二维码
  getQrCode() {
    return request.get('frontend/promotion/qrcode');
  }
};

// 地址相关接口
export const addressApi = {
  // 获取地址列表
  getList() {
    return request.get('frontend/address/list');
  },
  
  // 添加地址
  add(data) {
    return request.post('frontend/address/add', data);
  },
  
  // 修改地址
  update(id, data) {
    return request.put(`frontend/address/update/${id}`, data);
  },
  
  // 删除地址
  delete(id) {
    return request.delete(`frontend/address/delete/${id}`);
  },
  
  // 设为默认地址
  setDefault(id) {
    return request.post(`frontend/address/set-default/${id}`);
  }
};

// 首页相关接口
export const homeApi = {
  // 获取首页数据
  getData() {
    return request.get('frontend/home/data');
  },
  
  // 获取轮播图
  getBanners() {
    return request.get('frontend/home/banners');
  },
  
  // 获取公告
  getNotices() {
    return request.get('frontend/home/notices');
  }
};

// 消息相关接口
export const message = {
	// 获取未读消息数量
	getUnreadCount: () => {
		return request.get('frontend/message/unread-count', {
			server: 1
		});
	},
	
	// 获取消息列表
	getList: (params = {}) => {
		return request.get('frontend/message/list', {
			server: 1,
			...params
		});
	}
};

// 微信通知相关接口
export const wechat = {
	// 获取微信绑定状态和通知设置
	getNotifySettings: () => {
		return request.get('api/frontend/wechat.user/getNotifySettings');
	},
	
	// 保存通知设置
	saveNotifySetting: (data) => {
		return request.post('api/frontend/wechat.user/saveNotifySetting', data);
	},
	
	// 检查微信绑定状态
	checkBindStatus: () => {
		return request.get('api/frontend/wechat.user/checkBindStatus');
	},
	
	// 获取微信绑定二维码
	getBindQrCode: () => {
		return request.get('api/frontend/wechat.index/getBindQrCode');
	},
	
	// 解绑微信
	unbindWechat: () => {
		return request.post('api/frontend/wechat.user/unbind');
	}
}; 